var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9194 3.33289C10.7727 3.33289 3.33105 10.8096 3.33105 19.9996C3.33105 29.1896 10.8077 36.6662 19.9977 36.6662C29.1877 36.6662 36.6644 29.1896 36.6644 19.9996C36.6644 10.8096 29.1527 3.33289 19.9194 3.33289ZM19.9977 33.3329C12.6461 33.3329 6.66439 27.3512 6.66439 19.9996C6.66439 12.6479 12.6094 6.66622 19.9194 6.66622C27.3161 6.66622 33.3311 12.6479 33.3311 19.9996C33.3311 27.3512 27.3494 33.3329 19.9977 33.3329Z",
    fill: "#6d4096"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3311 11.6671H21.6644V23.3338H18.3311V11.6671ZM18.3311 25.0004H21.6644V28.3338H18.3311V25.0004Z",
    fill: "#6d4096"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCircle);
export default __webpack_public_path__ + "static/media/error-circle.4cf14e1ad92119b00cf8d5ce37a68563.svg";
export { ForwardRef as ReactComponent };